import { render, staticRenderFns } from "./RelatedProductsNavigation.vue?vue&type=template&id=6d1b47b9&scoped=true"
import script from "./RelatedProductsNavigation.vue?vue&type=script&lang=js"
export * from "./RelatedProductsNavigation.vue?vue&type=script&lang=js"
import style0 from "./RelatedProductsNavigation.vue?vue&type=style&index=0&id=6d1b47b9&prod&lang=stylus&scoped=true"
import style1 from "./RelatedProductsNavigation.vue?vue&type=style&index=1&id=6d1b47b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1b47b9",
  null
  
)

export default component.exports